import { create } from "zustand";
import { ReactNode } from "react";

type PageTitleState = {
    routeTitle: ReactNode;
    dynamicTitle: ReactNode;
    documentTitle: string;
    setRouteTitle: (v: ReactNode) => void;
    setDynamicTitle: (v: ReactNode) => void;
    setDocumentTitle: (v: string) => void;
    resetDynamicTitle: () => void;
    getFullTitle: () => ReactNode;
    getDocumentTitle: () => string;
};

export const usePageTitleStore = create<PageTitleState>((set, get) => ({
    routeTitle: "",
    dynamicTitle: "",
    documentTitle: "",
    setRouteTitle: (v) => set({ routeTitle: v }),
    setDynamicTitle: (v) => set({ dynamicTitle: v }),
    setDocumentTitle: (v) => set({ documentTitle: v }),
    resetDynamicTitle: () => set({ dynamicTitle: "" }),
    getFullTitle: () => {
        const { dynamicTitle, routeTitle } = get();
        return dynamicTitle || routeTitle || "";
    },
    getDocumentTitle: () => {
        const { documentTitle, dynamicTitle, routeTitle } = get();

        if (documentTitle && documentTitle.trim()) return documentTitle;
        if (typeof dynamicTitle === "string" && dynamicTitle.trim()) return dynamicTitle;
        if (typeof routeTitle === "string" && routeTitle.trim()) return routeTitle;
        return "ЕЦПП";
    },
}));